import { useFormContext } from "react-hook-form";
import { z } from "zod";

import { LEGAL_DOCUMENTS } from "../../../../constants";
import {
  ReservationAgreeButton,
  type ReservationAgreeButtonMessages,
} from "../../ui/buttons/reservation-agree-button";

import { DescriptionHeader } from "./description-header";

export const remoteSiteCancelFeeOptionsFormSchema = z
  .object({
    agreeRemoteCancelFeeTerms: z.boolean().nullable(),
  })
  .refine((data) => {
    if (data.agreeRemoteCancelFeeTerms == null) return true;
    return data.agreeRemoteCancelFeeTerms;
  });

export type DescriptionForRemoteSiteCancelFeeMessages = {
  heading: string;
  iconAlt: string;
  noticeBefore: string;
  legalLinkText: string;
  legalNoteAfter: string;
  agreeButtonLabel: string;
  agreeButtonMessages?: ReservationAgreeButtonMessages;
};

const JA_MESSAGES: DescriptionForRemoteSiteCancelFeeMessages = {
  heading: "遠方施設のため遠方キャンセルポリシーが適用されます",
  iconAlt: "飛行機の画像",
  noticeBefore:
    "遠方施設は14日前からキャンセル料が発生する場合があります。詳しくは",
  legalLinkText: "こちらの利用規則",
  legalNoteAfter: "をお読みいただき、同意の上でご利用ください。",
  agreeButtonLabel: "利用規則に同意します",
};

type Props = {
  skipAgreement?: boolean;
  messages?: DescriptionForRemoteSiteCancelFeeMessages;
};

export default function DescriptionForRemoteSiteCancelFeeFormPartial({
  skipAgreement = false,
  messages = JA_MESSAGES,
}: Props) {
  const { register } = useFormContext();

  return (
    <div className="mt-[20px] w-full space-y-[20px]">
      <DescriptionHeader
        iconSrc="/i/icon_airplane.svg"
        iconAlt={messages.iconAlt}
      >
        {messages.heading}
      </DescriptionHeader>
      {!skipAgreement && (
        <>
          <div className="text-xs md:text-sm">
            {messages.noticeBefore}
            <a
              data-analytics-id="reservation_form_clicked_remote_site_cancel_fee_policy"
              href={LEGAL_DOCUMENTS.cancelFeePolicy.url}
              target="_blank"
              className="font-bold underline"
            >
              {messages.legalLinkText}
            </a>
            {messages.legalNoteAfter}
          </div>
          <div className="flex justify-center">
            <ReservationAgreeButton
              label={messages.agreeButtonLabel}
              required
              inputRHFArgs={register(
                "remoteSiteCancelFeeOptions.agreeRemoteCancelFeeTerms",
              )}
              testId="remote-cancel-fee-agree-button"
              messages={messages.agreeButtonMessages}
            />
          </div>
        </>
      )}
    </div>
  );
}
